import type { FC } from "react";
import type { ModalProps } from "@uhg-harmony/react";
import { BaseTemplateFormModal, type BaseTemplateFormData } from "./BaseTemplateFormModal";

type CloneModalProps = ModalProps & {
  open: boolean;
  onClose: () => void;
  onConfirm?: (formData: BaseTemplateFormData) => void;
  isLoading?: boolean;
};

export const CloneModal: FC<CloneModalProps> = ({
  title,
  open,
  onClose,
  onConfirm,
  isLoading = false,
}) => (
  <BaseTemplateFormModal
    title={title || "Clone Template"}
    open={open}
    onClose={onClose}
    onConfirm={(formData: BaseTemplateFormData) => onConfirm?.(formData)}
    initialTemplateName=""
    confirmButtonText="Clone"
    isLoading={isLoading}
    errorMessage=""
    showCategoryDropdown
    showFolderDropdown
    defaultFolderSelection="Drafts"
  />
);

